export default __webpack_public_path__ + "static/media/2.c746349c.png";